import { render, staticRenderFns } from "./site-choice.vue?vue&type=template&id=c744a278&scoped=true"
import script from "./site-choice.vue?vue&type=script&lang=js"
export * from "./site-choice.vue?vue&type=script&lang=js"
import style0 from "./site-choice.vue?vue&type=style&index=0&id=c744a278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c744a278",
  null
  
)

export default component.exports